var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-datatable-wrapper"},[_c('sf-data-table',{ref:"dataTable",staticStyle:{"height":"260px"},attrs:{"index":"","scrId":_vm.scrId,"paging":"","columns":_vm.columns,"rows":_vm.rows,"stripe":false},on:{"changedPage":_vm.changedPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }